import { CentralPerm } from "@enum/central/central-perm.enum";
import { LinkRoutes } from "@enum/central/link-routes.enum";
import { CommonPerm } from "@enum/common/permission/common-perm.enum";

export const AdministrativeSection = [
    {
        section: 'Administrativo',
        permission: [
            '*',
            CentralPerm.ServicePlans_View,
            CentralPerm.Companies_View,
            CentralPerm.PaymentProviderConfigs_View,
            // União das telas da seção: "Usuários do sistema" faltava, e quem
            // só tinha `users.view` via o item sem o título da seção. Créditos
            // saiu para a seção Vendas.
            CommonPerm.Users_View,
            CentralPerm.AccountingFirms_View,
        ],
    },
    {
        title: 'Empresas',
        root: false,
        icon: 'apartment',
        page: LinkRoutes.LIST_COMPANIES,
        permission: ['*', CentralPerm.Companies_View],
        bullet: 'dot',
    },
    {
        title: 'Consumo de recursos',
        root: false,
        icon: 'bar_chart',
        page: LinkRoutes.LIST_RESOURCE_CONSUMPTION,
        permission: ['*', CentralPerm.Companies_View],
        bullet: 'dot',
    },
    {
        title: 'Planos de serviço',
        root: true,
        icon: 'person',
        page: LinkRoutes.LIST_SERVICE_PLANS,
        permission: ['*', CentralPerm.ServicePlans_View],
        bullet: 'dot',
    },
    {
        // Fase 1b (Transfeera): a escolha do provedor por instrumento saiu do
        // cadastro de empresa e virou tela própria, sob permissão própria
        // (decisão do dono, 05/09/2026). A permissão declarada aqui é a MESMA
        // da guarda da rota — menu mais largo levaria a um bounce mudo para o
        // dashboard; menu mais estreito esconderia tela que a pessoa pode usar.
        title: 'Provedores de cobrança',
        root: true,
        icon: 'account_balance',
        page: LinkRoutes.LIST_PAYMENT_PROVIDER_CONFIGS,
        permission: ['*', CentralPerm.PaymentProviderConfigs_View],
        bullet: 'dot',
    },
    {
        title: 'Usuários do sistema',
        permission: ['*', CommonPerm.Users_View],
        icon: 'person_edit',
        page: LinkRoutes.LIST_USERS,
        bullet: 'dot',
    },
    {
        title: 'Escritórios contábeis',
        permission: ['*', CentralPerm.AccountingFirms_View],
        // Era 'apartment' — repetia com "Empresas" (dono, 22/09/2026: ícone
        // único por item do menu). `corporate_fare` é outro prédio do mesmo
        // catálogo, visualmente distinto do residencial de "Empresas".
        icon: 'corporate_fare',
        page: LinkRoutes.LIST_ACCOUNTING_FIRMS,
        bullet: 'dot',
    },
]
